const t = "_wrapper_13ayp_1", p = "_withPresetIcon_13ayp_16", e = "_title_13ayp_28", r = "_icon_13ayp_31", n = "_titleIconWrapper_13ayp_44", _ = "_linkWrapper_13ayp_55", a = {
  wrapper: t,
  withPresetIcon: p,
  title: e,
  icon: r,
  titleIconWrapper: n,
  linkWrapper: _
};
export {
  a as default,
  r as icon,
  _ as linkWrapper,
  e as title,
  n as titleIconWrapper,
  p as withPresetIcon,
  t as wrapper
};
